<div class="connection" *ngIf="connectionStatus === 'OFFLINE'">
  <p class="connection__message">No se encuentra conexión a internet</p>
</div>
